import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { offerAsset } from "../asset/fragments";

export const INSURANCE_DOCUMENT_CREATED = gql`
  subscription insuranceDocumentCreated {
    insuranceDocumentCreated {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const EXTERNAL_OFFER_DATA_RETRIEVED = gql`
  subscription externalOfferDataRetrieved {
    externalOfferDataRetrieved {
      details {
        ...offerAsset
      }
      financingType
      uniqueId
      partnerTypeId
      filterContactDataForDealer
      errorMessage
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
  ${offerAsset}
`;

export const EXTERNAL_OFFER_DATA_COPIED = gql`
  subscription externalOfferDataCopied {
    externalOfferDataCopied {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
